import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Text extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        value: PropTypes.string
    };

    onChange = e => this.props.onChange(e.target.value);

    render() {
        return <input
            className='text-input'
            type='text'
            value={this.props.value}
            disabled={this.props.disabled}
            onChange={this.onChange} />;
    }
}
